export const TITLE = 'Regulated Rates';

export const SUBTITLE =
  'These options will be offered to every customer who is sent a job from your account. Prices are indicative and are subject to change';
